export const CHAINS = {
    polygon: {
        id: 'polygon',
        evmChainId: 137,
        name: 'Polygon PoS',
        nativeSymbol: 'MATIC',
        rpcUrlEnv: 'POLYGON_RPC_URL',
        minConfirmations: 128,
        blockExplorer: 'https://polygonscan.com',
        testnet: false,
    },
    base: {
        id: 'base',
        evmChainId: 8453,
        name: 'Base',
        nativeSymbol: 'ETH',
        rpcUrlEnv: 'BASE_RPC_URL',
        minConfirmations: 5,
        blockExplorer: 'https://basescan.org',
        testnet: false,
    },
    arbitrum: {
        id: 'arbitrum',
        evmChainId: 42161,
        name: 'Arbitrum One',
        nativeSymbol: 'ETH',
        rpcUrlEnv: 'ARBITRUM_RPC_URL',
        minConfirmations: 1,
        blockExplorer: 'https://arbiscan.io',
        testnet: false,
    },
    optimism: {
        id: 'optimism',
        evmChainId: 10,
        name: 'Optimism',
        nativeSymbol: 'ETH',
        rpcUrlEnv: 'OPTIMISM_RPC_URL',
        minConfirmations: 5,
        blockExplorer: 'https://optimistic.etherscan.io',
        testnet: false,
    },
    bsc: {
        id: 'bsc',
        evmChainId: 56,
        name: 'BNB Smart Chain',
        nativeSymbol: 'BNB',
        rpcUrlEnv: 'BSC_RPC_URL',
        minConfirmations: 15,
        blockExplorer: 'https://bscscan.com',
        testnet: false,
    },
    avalanche: {
        id: 'avalanche',
        evmChainId: 43114,
        name: 'Avalanche C-Chain',
        nativeSymbol: 'AVAX',
        rpcUrlEnv: 'AVALANCHE_RPC_URL',
        minConfirmations: 6,
        blockExplorer: 'https://snowtrace.io',
        testnet: false,
    },
    'polygon-amoy': {
        id: 'polygon-amoy',
        evmChainId: 80002,
        name: 'Polygon Amoy (testnet)',
        nativeSymbol: 'POL',
        rpcUrlEnv: 'POLYGON_AMOY_RPC_URL',
        minConfirmations: 5,
        blockExplorer: 'https://amoy.polygonscan.com',
        testnet: true,
    },
    'base-sepolia': {
        id: 'base-sepolia',
        evmChainId: 84532,
        name: 'Base Sepolia (testnet)',
        nativeSymbol: 'ETH',
        rpcUrlEnv: 'BASE_SEPOLIA_RPC_URL',
        minConfirmations: 1,
        blockExplorer: 'https://sepolia.basescan.org',
        testnet: true,
    },
    'arbitrum-sepolia': {
        id: 'arbitrum-sepolia',
        evmChainId: 421614,
        name: 'Arbitrum Sepolia (testnet)',
        nativeSymbol: 'ETH',
        rpcUrlEnv: 'ARBITRUM_SEPOLIA_RPC_URL',
        minConfirmations: 1,
        blockExplorer: 'https://sepolia.arbiscan.io',
        testnet: true,
    },
};
export function isTestnet(chainId) {
    return CHAINS[chainId].testnet;
}
export const MAINNET_CHAIN_IDS = Object.values(CHAINS)
    .filter((c) => !c.testnet)
    .map((c) => c.id);
export const TESTNET_CHAIN_IDS = Object.values(CHAINS)
    .filter((c) => c.testnet)
    .map((c) => c.id);
export const ALL_CHAIN_IDS = Object.keys(CHAINS);
export function isChainId(value) {
    return typeof value === 'string' && value in CHAINS;
}
export function getChain(id) {
    return CHAINS[id];
}
export function getChainByEvmId(evmChainId) {
    return Object.values(CHAINS).find((c) => c.evmChainId === evmChainId);
}
//# sourceMappingURL=index.js.map